import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DOCUMENT } from "@angular/common";
import { Observable, Subject } from "rxjs";
import dayjs from "dayjs";
import { Dictionary } from "./store/models/common_types";
import { NzMessageService } from "ng-zorro-antd/message";
import timezone from "dayjs/plugin/timezone.js";
dayjs.extend(timezone);

@Injectable({
  providedIn: "root",
})
export class AppService {
  apiEP: string = window.apiUrl;
  legacyUrl = `${window.caUrl}/app`;
  privateIPOfUser = "";
  currentPath: string;
  PG_EXCLUDED_FEATURE: Array<string> = [
    "TEAR_SHEET_REQUEST",
    "TEAR_SHEET_DOWNLOAD",
  ];

  updateLeftPanelSource = new Subject<Dictionary<any>>();
  updateLeftPanelSource$ = this.updateLeftPanelSource.asObservable();
  globalSubheaderActionSource = new Subject<any>();
  onGlobalSubheaderAction = this.globalSubheaderActionSource.asObservable();
  leftPanelTemplateActionSouce = new Subject<any>();
  onLeftPanelTemplateAction = this.leftPanelTemplateActionSouce.asObservable();
  mexPageExcelDisableChange = new Subject<any>();
  onMexPageExcelDisableChange = this.mexPageExcelDisableChange.asObservable();

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private message: NzMessageService,
  ) {
    this.getUserIP((ip) => {
      this.privateIPOfUser = ip;
    });
  }
  logUserAction(event, ticker, cut, feature, extras, source, actionSource) {
    if (!event || (event && !event.originalEvent && event.isTrigger)) {
      return;
    }

    const url = `${window.apiUrl}/api/loguseraction/`;
    this.currentPath = window.location.pathname;
    const postData = {
      feature: feature,
      extras: [{ ...extras, b_tab: window.b_tab }],
      userIP: [this.privateIPOfUser],
    };

    if (ticker && ticker.length !== 0) {
      postData["company"] = [ticker];
    }

    if (cut && cut.length !== 0) {
      postData["cut"] = [cut];
    }

    if (source && source.length !== 0) {
      postData["source"] = [source];
    }

    if (actionSource && actionSource.length !== 0) {
      postData["action_source"] = actionSource;
    }

    const pgExcludedFeature = this.PG_EXCLUDED_FEATURE.includes(feature);
    if (window.pg && !pgExcludedFeature && this.currentPath.includes("/mex/")) {
      postData["pg"] = window.pg;
    }

    this.http.post(url, postData).subscribe();
  }

  getUserIP(onNewIP) {
    //  onNewIp - your listener function for new IPs
    //compatibility for firefox and chrome
    const myPeerConnection =
      window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection;
    if (!myPeerConnection) {
      return;
    }
    try {
      const pc = new myPeerConnection({
          iceServers: [],
        }),
        noop = () => {
          return;
        },
        localIPs = {},
        ipRegex =
          /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

      const iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      };

      //create a bogus data channel
      pc.createDataChannel("");

      // create offer and set local description
      pc.createOffer()
        .then(function (sdp) {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) return;
            line.match(ipRegex).forEach(iterateIP);
          });

          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch(function (reason) {
          // An error occurred, so handle the failure to connect
          console.error(reason);
        });

      //listen for candidate events
      pc.onicecandidate = function (ice) {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        )
          return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    } catch (err) {
      console.error(err.message);
    }
  }

  getCookie(name) {
    let cookieValue = null;
    if (this._document.cookie && this._document.cookie !== "") {
      const cookies = this._document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === `${name}=`) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  getActivityFeedData(params): Observable<any> {
    const userTimezone = dayjs.tz.guess();
    let apiUrl = `${
      window.apiUrl
    }/app/alerts/get_notifications?timezone=${encodeURIComponent(
      userTimezone,
    )}&limit=${params.limit}&watcherid=${params.watcherId}`;
    if (params.companyId) apiUrl += `&company_id=${params.companyId}`;
    if (params.eventPublistTime) {
      apiUrl = `${apiUrl}&eventPublishTime__lt=${params.eventPublistTime}`;
    }
    if (params.type === "alerts") {
      apiUrl = `${apiUrl}&alerts_only=1`;
    }
    if (params.type__name_not) {
      apiUrl = `${apiUrl}&type__name_not=${params.type__name_not}`;
    }
    return this.http.get(apiUrl);
  }

  // excelDownload(event: any, excelTrackerId, tickerName, exportType?: string, actionSource?: string, extras?: any) {
  excelDownload(exportType?: string, extraParams?: any) {
    if (exportType === "tear_sheet") {
      this.logUserAction(
        event,
        extraParams.tickerName,
        "",
        "TEAR_SHEET_DOWNLOAD",
        { trackerId: extraParams.excelTrackerId },
        "",
        extraParams.actionSource,
      );
    }

    let url = `/api/excel_file_download?exceltrackerid=${extraParams.excelTrackerId}`;
    let uniqeId = "";
    uniqeId = extraParams.excelTrackerId;
    if (exportType === "research_download") {
      url = `/api/downloadresearchzip?exceltrackerid=${extraParams.excelTrackerId}`;
      uniqeId = extraParams.excelTrackerId;
    } else if (exportType === "model_download") {
      if (!extraParams.cellId) {
        url = `/api/model?TransactionId=${extraParams.transactionId}&source=${
          extraParams.source
        }&company=${extraParams.companyId}&pg=${encodeURIComponent(
          extraParams.pg,
        )}&cut=${extraParams.cut}`;
        uniqeId = extraParams.transactionId;
        if (extraParams.file_type) {
          url += `&fileType=${extraParams.file_type}`;
        }
      } else {
        url = `/api/model?documentid=${extraParams.documentid}&source=${
          extraParams.source
        }&pg=${encodeURIComponent(extraParams.pg)}&downloadType=${
          extraParams.downloadType
        }&cellId=${extraParams.cellId}&ticker=${extraParams.ticker}&cut=${
          extraParams.cut
        }`;
        uniqeId = extraParams.documentid;
      }
    } else if (exportType === "watchlist_download") {
      url = `/watcher/export_watchlist/?watchlistid=${extraParams.watchlistId}&shared=${extraParams.isShared}`;
      uniqeId = `watchlist-${extraParams.watchlistId}`;
    }

    const iFrameToLoad = this._document.createElement("iframe");
    const body = this._document.getElementsByTagName("body")[0];
    iFrameToLoad.setAttribute("id", `${exportType}_${uniqeId}`);
    iFrameToLoad.setAttribute("name", `${exportType}_${uniqeId}`);
    iFrameToLoad.setAttribute("src", url);
    iFrameToLoad.setAttribute("style", "visibility:hidden; display:none");
    body.appendChild(iFrameToLoad);
    iFrameToLoad.onload = () => {
      let res =
        frames[`${exportType}_${uniqeId}`].document.getElementsByTagName(
          "body",
        )[0].innerHTML;
      if (res) {
        try {
          res = JSON.parse(res);
          if (res.status === "error") {
            if (exportType === "model_download") {
              this.message.error(`Error: ${res.message}`, {
                nzDuration: 2000,
              });
            }
            console.error(
              `Failed to download file, ${res["filename"]} for source  .`,
            );
          }
          if (res.force_logout) {
            if (exportType === "model_download") {
              window.location.href = `${this.legacyUrl}/homepage/?force_logout=true`;
            }
          }
        } catch (err) {
          if (exportType === "model_download") {
            if (
              res.indexOf("VAHOMEPAGE") > -1 ||
              res.indexOf("Forgot Password") > -1
            ) {
              window.location.href = `${this.legacyUrl}/homepage/?force_logout=true`;
            }
          }
          console.error(err);
        }
      }
    };
    if (extraParams.iFrameDestructCb) {
      const startIFrameTime = new Date().getTime();
      const checkInterval = setInterval(() => {
        const iFrameToGet = this._document.getElementById(
          `${exportType}_${uniqeId}`,
        ) as HTMLIFrameElement;
        const iFrame =
          iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
        /*
        This check will run till the iFrame either doesn't load or for a max of 30secs
        Or till the ready state of the iFrame doesn't evaluate
      */

        if (
          iFrame.readyState === "complete" ||
          iFrame.readyState === "interactive" ||
          new Date().getTime() - startIFrameTime > 30000
        ) {
          clearInterval(checkInterval);
          //this._document.getElementById(`${exportType}_${uniqeId}`).remove();
          extraParams.iFrameDestructCb();
          return;
        }
      }, 2000);
    }
  }

  exportToExcel(pageName: string, ticker: string, extra?: Dictionary<any>) {
    let url: Observable<any> = null;
    switch (pageName) {
      case "revisions":
        url = this.http.get(
          `${window.apiUrl}/api/surpriserevisionexport/?ticker=${ticker}&analysis_type=Revision&revision=${extra.revisionDate}`,
        );
        break;
      case "company":
        url = this.http.get(
          `${window.apiUrl}/addin/export?template_type=${extra.template_type}&export_type=${extra.export_type}&ticker=${ticker}&baseline=${extra.baseline}`,
        );
        break;
      case "surprise":
        url = this.http.get(
          `${window.apiUrl}/api/surpriserevisionexport/?ticker=${ticker}&analysis_type=Surprise`,
        );
        break;
      case "vsconsensus":
      case "valuation company":
      case "valuation vspeers grid":
      case "valuation vspeers list":
        url = this.http.get(
          `${window.apiUrl}/addin/export?template_type=${extra.template_type}&export_type=${extra.export_type}&ticker=${ticker}&source=${extra.source}`,
        );
        break;
      default:
        break;
    }
    return url;
  }

  verifyEmailAddress(emailId: string) {
    //validation for basic email structure. Failing this, don't let the user pass.
    const errReg = new RegExp("[^@]+@[^@]+.[^@]+", "i");
    //validation for characters in the email Id. Failing this, show only a warning message, but let them pass.
    const warnReg = new RegExp(
      "^[a-z0-9!#$%&'*+/=?^_{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-][a-z0-9]+)?.)+[a-z0-9](?:[a-z0-9-][a-z0-9])?$",
      "i",
    );
    const errOut = errReg.test(emailId);
    const warnOut = warnReg.test(emailId);
    return { hasError: !errOut, hasWarning: !warnOut };
  }

  cloneArray(arr) {
    const res = arr.map((a) => {
      return { ...a };
    });
    return res;
  }

  /**
   * This method deepclones javascript object passed as input.
   *
   *
   * This is useful when you don't want the original and the copy objects to point to same
   * reference (memory location)
   *
   * @param obj {Object} javascript object / array to deep clone
   * @returns cloned (copy) of @param obj
   */
  superClone(obj) {
    if (obj === null || typeof obj !== "object" || "isActiveClone" in obj)
      return obj;

    let temp = null;
    if (obj instanceof Date) temp = new Date(obj) as any;
    else temp = obj.constructor();

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        obj["isActiveClone"] = null;
        temp[key] = this.superClone(obj[key]);
        delete obj["isActiveClone"];
      }
    }
    return temp;
  }

  /**
   * Super clone method written above, fails for objects with circular dependency.
   * It also fails for frozen/immutable objects as it modifies original object by doing obj["isActiveClone"] = null
   * @param obj object to be cloned
   * @param hash Map or object to be used as cache. It internally keeps a cache to reolve circular dependencies
   * i.e. if there is circular dependency, instead of going further in and resolving it and eventually die out due
   * to infinite loop, it resolves that dependency from cache.
   * Better Leave this argument empty, if you don't understand it.
   * @returns cloned object
   */
  deepClone(obj, hash = new WeakMap()) {
    let result = null;
    // Do not try to clone primitives or functions
    if (Object(obj) !== obj || obj instanceof Function) return obj;
    if (hash.has(obj)) return hash.get(obj); // Cyclic reference
    try {
      // Try to run constructor (without arguments, as we don't know them)
      result = new obj.constructor();
    } catch (e) {
      // Constructor failed, create object without running the constructor
      result = Object.create(Object.getPrototypeOf(obj));
    }
    // Optional: support for some standard constructors (extend as desired)
    if (obj instanceof Map)
      Array.from(obj, ([key, val]) =>
        result.set(this.deepClone(key, hash), this.deepClone(val, hash)),
      );
    else if (obj instanceof Set)
      Array.from(obj, (key) => result.add(this.deepClone(key, hash)));
    // Register in hash
    hash.set(obj, result);
    // Clone and assign enumerable own properties recursively
    return Object.assign(
      result,
      ...Object.keys(obj).map((key) => ({
        [key]: this.deepClone(obj[key], hash),
      })),
    );
  }
  /**
   * clone / create copy of a date object which doesn't point the reference of original date obj
   * @param date {Date}
   * @returns copy of @param date
   */
  cloneDate = (date: Date) => {
    if (!date) {
      return date;
    }

    return new Date(date);
  };

  getRecentlyVisitedCompanies(): Observable<any> {
    return this.http.get(
      `${window.apiUrl}/watcher/get_recently_visited_companies/`,
    );
  }
  /**
   *
   * @param data data array that is to be sorted
   * @param propertyPath path on the data to the key on which sorting will be performed
   * @param reverse wheter to sort descending, default false
   * @param applyTransform function to modify the key on which sorting is performed,
   *                        accepts the key, return transformed/modified key
   *
   *
   * Sort data array based on a nested key.
   * eg. if your array item is { company: user: { userid: 'xxxx', name: 'yyy'} }
   *    and you want to sort this array over userid
   */
  basicSort(
    data: any[],
    propertyPath: (string | number)[] = [],
    reverse = false,
    applyTransform: Function = null,
  ) {
    return data.sort((a: any, b: any) => {
      const a_ = this.getNestedProperty(a, propertyPath, applyTransform);
      const b_ = this.getNestedProperty(b, propertyPath, applyTransform);

      const reverseFactor = reverse ? -1 : 1;

      return (Number(a_ > b_) - Number(a_ < b_)) * reverseFactor;
    });
  }

  /**
   *
   * @param obj object from which property is to be extracted
   * @param propertyPath array of string or number, giving the path to the property
   *                      that is tobe extracted
   * @param applyTransform function to modify the extracted property before return
   *
   * eg. const obj = { company: user: { userid: 'xxxx', name: 'yyy'} }
   *  const capitalizedName
   *  = getNestedProperty(obj, ['company', 'user', 'name'], (name: string) => name.toUpperCase())
   */
  getNestedProperty = (
    obj: any,
    propertyPath: (string | number)[],
    applyTransform: Function = null,
  ): any => {
    let nestedProperty = obj;
    for (const property of propertyPath) {
      nestedProperty = nestedProperty[property];
    }

    if (applyTransform) {
      nestedProperty = applyTransform(nestedProperty);
    }
    return nestedProperty;
  };

  //compare deeply nested json objects.
  compare = (original: any, shadow: any): boolean => {
    if (typeof shadow === typeof original) {
      //orginal and shadow are null or undefined
      if (
        shadow === null ||
        shadow === undefined ||
        original === null ||
        original === undefined
      ) {
        return shadow === original;
      }

      //original and shadow are primitive / immutable types
      if (
        typeof shadow === "number" ||
        typeof shadow === "string" ||
        typeof shadow === "boolean"
      ) {
        return shadow === original;
      }

      //original and shadow are objects or arrays
      //return false if different key lengths
      if (Object.keys(original).length !== Object.keys(shadow).length) {
        return false;
      }

      let positiveAssumption = true;
      for (const key in original) {
        //check if original has the key we found on shadow
        //check if so far all the key-val pairs were equal.
        if (shadow[key] === undefined || !positiveAssumption) {
          return false;
        }

        positiveAssumption =
          positiveAssumption && this.compare(original[key], shadow[key]);
      }
      return positiveAssumption;
    }
    //if initial types of original and shadow dont match
    return false;
  };

  // format value based on given precision
  formatValue(value: number, precision?: number) {
    const dpPrecision = isNaN(precision) ? 2 : precision;
    return value < 0
      ? this.addThousandsSeparator(-value, dpPrecision)
      : this.addThousandsSeparator(value, dpPrecision);
  }

  addThousandsSeparator(value: number, decimals: number) {
    let val = "";
    //for (15066.084470789277,1) => 15,066.1
    // if (!Number.isInteger(value)) return value.toLocaleString("en-US", { maximumFractionDigits: decimals });
    // //for (67000) => 67,000.00
    // if (Number.isInteger(value)) return value.toLocaleString("en-US", { minimumFractionDigits: decimals });

    val = !Number.isInteger(value)
      ? value.toLocaleString("en-US", { maximumFractionDigits: decimals })
      : value.toLocaleString("en-US", { minimumFractionDigits: decimals });
    /*
      Adding this to put in the number of decimals mentioned in the precision, to only a whole number after rounding it off.
      Ex: value = 39.99448302578609916744757663 and decimals = 1
      Original O/P: 40
      New O/P: 40.0
      */
    if (decimals !== 0 && !val.includes(".")) {
      val = `${val}.${Array(decimals + 1).join("0")}`;
    }

    if (
      decimals !== 0 &&
      val.includes(".") &&
      val.split(".")[1].length !== decimals
    ) {
      val = `${val}0`;
    }

    return val;
  }

  /**
   *
   * @param dateObj Javascript Date object
   * @returns formattedDate string as MM-DD-YYYY
   */
  getFormattedDate = (dateObj: Date, formatTo = "MM-DD-YYYY") => {
    if (dateObj === null) {
      return null;
    }
    const formattedDate = dayjs(dateObj).format(formatTo.toUpperCase());
    return formattedDate;
  };

  validateInputDate = (date: Date) => {
    if (date === null) {
      return { valid: false, msg: "Format date as yyyy-mm-dd" };
    }

    if (this.getFormattedDate(date) === this.getFormattedDate(new Date())) {
      return { valid: false, msg: "Only previous dates can be defined" };
    }

    return { valid: true, msg: "" };
  };

  daysIn(year, month) {
    const days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    const isLeapYear = year % 100 !== 0 && year % 4 === 0;
    const isCetennialLeapYear = year % 100 === 0 && year % 400 === 0;
    days[1] = days[1] + Number(isCetennialLeapYear || isLeapYear);

    return days[month];
  }

  getDateDiff(startDate, endDate) {
    const maxDaysInStartMonth = this.daysIn(
      startDate.getFullYear(),
      startDate.getMonth(),
    );
    const difference = this.calculateDateDiff(startDate, endDate);

    //if no. of days in startDate's month can be completed, do it
    if (difference.days >= maxDaysInStartMonth) {
      difference.days -= maxDaysInStartMonth;
      difference.months += 1;
    }

    return difference;
  }

  /**
   *
   * @param startDate javascript date object
   * @param endDate javascript date object -- defaults to today
   * @returns time difference between dateObj and today in format -xxM xxD
   */
  getFormattedDateDifference(startDate: Date, endDate = new Date()) {
    const startDate_ = new Date(startDate.getTime());
    const endDate_ = new Date(endDate.getTime());
    const { days: diffDay, months: diffMonth } = this.getDateDiff(
      startDate_,
      endDate_,
    );
    let diffWeek = 0;
    if (diffMonth === 0) {
      //difference is only in days.
      //show as week if no. of days is multiple of 7
      const remainder = diffDay % 7;

      if (remainder === 0 && diffDay / 7 <= 4) {
        diffWeek = diffDay / 7;
      }
    }

    if (diffWeek > 0) {
      return `-${diffWeek}W`;
    }

    if (diffMonth > 0 && diffDay === 0) {
      return `-${diffMonth}M`;
    }

    if (diffDay > 0 && diffMonth === 0) {
      return `-${diffDay}D`;
    }

    return `-${diffMonth}M ${diffDay}D`;
  }

  setDateToDayStart(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  /**
   *
   * @param startDate
   * @param endDate
   * calculate date difference in months and days
   * NOTE: THIS FUNCTION MUTATES THE INPUT
   */
  calculateDateDiff(startDate, endDate) {
    if (endDate.getTime() - startDate.getTime() < 0) {
      const tempDate = startDate;
      startDate = endDate;
      endDate = tempDate;
    }
    //set both dates to start of the day
    this.setDateToDayStart(startDate);
    this.setDateToDayStart(endDate);

    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    const startMonth = startDate.getMonth();
    const endMonth = endDate.getMonth();

    //check if start and end both fall in same month
    //this means diff is only in days
    if (startYear === endYear && startMonth === endMonth) {
      return {
        days: endDate.getDate() - startDate.getDate(),
        months: 0,
      };
    }

    //no. of calendar days in dateStart's month
    const maxDaysInStartMonth = this.daysIn(startYear, startMonth);
    //no. of days from dateStart's date to month end
    const daysToMonthEndFromStart =
      maxDaysInStartMonth - startDate.getDate() + 1;

    //incrementing month => if december also increment year
    startDate.setFullYear(startYear + Math.floor((startMonth + 1) / 12));
    startDate.setDate(1);
    startDate.setMonth((startMonth + 1) % 12);

    const difference = this.calculateDateDiff(startDate, endDate);
    const shouldCountAsMonth = maxDaysInStartMonth === daysToMonthEndFromStart;
    return {
      days:
        (shouldCountAsMonth ? 0 : daysToMonthEndFromStart) + difference.days,
      months: (shouldCountAsMonth ? 1 : 0) + difference.months,
    };
  }

  /**
   *
   * @param date date as a string in format MM-DD-YY
   * @returns Javascript date object
   */
  getDateObjectFrom = (date: string, format?: string) => {
    let dateObj = null;
    if (format !== undefined) {
      dateObj = dayjs(date, format).toDate();
    } else {
      dateObj = dayjs(date, "MM-DD-YYYY").toDate();
    }
    // const dateObj = dayjs(date, "MM-DD-YYYY").toDate();
    // const dateObj = dayjs(date, "YYYY-DD-MM").toDate();
    return dateObj;
  };

  getDuplicateObject = (inputObject) => {
    // Create an array or object to hold the values
    const duplicateObject = Array.isArray(inputObject) ? [] : {};
    let value = "";
    let key = "";
    if (typeof inputObject !== "object" || inputObject === null) {
      return inputObject; // Return the value if inputObject is not an object
    }

    for (key in inputObject) {
      value = inputObject[key];
      // Recursively (deep) copy for nested objects
      if (typeof value !== "function") {
        duplicateObject[key] = this.getDuplicateObject(value);
      } else {
        this.getDuplicateObject(value);
      }
    }
    return duplicateObject;
  };

  getCurrentUTCTime() {
    const today = new Date();
    const currentTime = today.toUTCString();
    return currentTime;
  }

  /**
   *
   * @param value Accepts a string input
   * @description The encodeURIComponent does not encode !'()* characters.
   * Use this in places like tab(pg) values.
   * Ex: NewIFRS(3) is a tab of BAML for 005930_KR
   */
  fixedEncodeURIComponent(value: string) {
    return encodeURIComponent(value).replace(/[!'()*]/g, function (c) {
      return `%${c.charCodeAt(0).toString(16)}`;
    });
  }

  downloadFileWithIFrame(downloadUrl: string, iFrameId: string) {
    const iFrameToLoad = this._document.createElement("iframe");
    const body = this._document.body;
    iFrameToLoad.id = iFrameId;
    iFrameToLoad.name = iFrameId;
    iFrameToLoad.src = downloadUrl;
    iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
    body.appendChild(iFrameToLoad);
    setTimeout(() => {
      this._document.getElementById(iFrameId).remove();
    }, 240000);
  }

  /**
   * This method is used to format the std line item data into an object
   * form that is compatible for in-memory search on FE
   * @param stdData - object of std line item data
   */
  formatStdLineItemsData(stdData) {
    const formattedStdLineItems = [];
    for (const item of stdData) {
      const formattedTabSliData = [];
      // format the tab_sli_data to match data shape of lineItems required for LineitemSearchComponent component
      for (const lineItem of item.tab_sli_data) {
        formattedTabSliData.push({
          ...lineItem,
          label: lineItem.name,
          sli_id_count: lineItem.sli_id_count,
          id: lineItem.uniquesliid || lineItem.sli_id || lineItem.sliid,
          disabled: false,
          isLeaf: true,
          level: 2,
          header: false,
          isCollapsed: true,
        });
      }
      const currentItem = {
        tab_full_name: item.tab_full_name,
        tab_short_name: item.tab_short_name,
        tab_sli_data: formattedTabSliData,
      };
      formattedStdLineItems.push(currentItem);
    }
    return formattedStdLineItems;
  }

  /**
   * Makes post api call to get the periods data, which is required in period filter
   * @param {array} tickers - array of ticker ids
   */
  getPeriodsWithData(tickers) {
    const tickersArr = tickers && tickers.length ? tickers : [];
    return this.http.post(`${this.apiEP}/api/fetch_available_periods`, {
      tickers: tickersArr,
    });
  }
}
